import React from 'react';

interface TabItem {
  id: string;
  label: string;
  component?: string;
}

interface TestTabsProps {
  tabs?: TabItem[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
}

const TestTabs: React.FC<TestTabsProps> = ({ 
  tabs,
  activeTab = 'tab1',
  onTabChange
}) => {
  const defaultTabs: TabItem[] = [
    { id: 'tab1', label: '📊 Data Table', component: 'DataTableCrudTest' },
    { id: 'tab2', label: '🌲 Data Tree', component: 'DataTreeCrudTest' },
    { id: 'tab3', label: '🎯 Card Grid', component: 'CardGridTest' },
    { id: 'tab4', label: '📄 Sidebar Doc', component: 'SidebarDocumentTest' },
    { id: 'tab5', label: '🏗️ Layout Demo', component: 'LayoutVariationsDemo' },
    { id: 'tab6', label: '🧩 Component Demo', component: 'ComponentDemo' }
  ];

  const tabItems = tabs || defaultTabs;

  return (
    <>
      {tabItems.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange && onTabChange(tab.id)}
          className={`interactive-tab-button ${activeTab === tab.id ? 'active' : ''}`}
        >
          {tab.label}
        </button>
      ))}
    </>
  );
};

export default TestTabs;